import React from 'react'
import Slider from 'react-slick'
import close from '../images/close.svg'

class ColorSelector extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      bitsColors: this.props.bits[this.props.slide].colors
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.slide != this.props.slide) {
      this.setState({
        bitsColors: this.props.bits[this.props.slide].colors
      })
    }
  }

  renderColor(color, index) {
    const checked = this.props.color.code === color.code
    const colorSwatchUrl = color.swatch.resize.src
    const classChecked = checked ? "--checked" : ""
    return (
      <label key={color.sku}>
        <div
          className={`button--round color-selector__button${classChecked}`}
        >
          <div style={{backgroundImage: `url('${colorSwatchUrl}')`}}/>
          <input
            name={color.code}
            className="color-selector__checkbox"
            type="checkbox"
            checked={checked}
            onChange={() => this.props.handleColorChange(color, index)}
          />
        </div>
      </label>
    )
  }

  render() {
    return (
      <div className={`color-selector__dropdown${this.props.cssModifier}`}>
        <img
          src={close}
          className="button--close"
          onClick={() => this.props.handleCloseModal()}
        />
        <form className="color-selector__dropdown__container">
          {this.state.bitsColors.map((color, i) =>
            this.renderColor(color, i)
          )}
        </form>
      </div>
    )
  }
}

export default ColorSelector



// WEBPACK FOOTER //
// ./src/components/ColorSelector.js